import { useEffect, useState } from 'react'

const pad = (value: number) => String(value).padStart(2, '0')

export function useCountdown(totalSeconds: number) {
  const [remaining, setRemaining] = useState(totalSeconds)

  useEffect(() => {
    if (remaining <= 0) return
    const id = window.setInterval(() => {
      setRemaining((value) => (value <= 1 ? 0 : value - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [remaining])

  return {
    remaining,
    isExpired: remaining <= 0,
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
  }
}
